/**
 * SSR-safe reactive view of "is this the installed app experience".
 *
 * `isPWAInstalled()` (utils/helpers) depends on client-only injections (`$pwa` /
 * `$appDeviceInfo`), so it always returns `false` during SSR. Calling it inline in a
 * template therefore risks a hydration mismatch (server renders the non-installed branch,
 * the client may render the installed one).
 *
 * This composable avoids that by seeding from the build-time app target (`isApp()`) — the
 * Capacitor app build is always the installed/native app — and only resolving the runtime
 * PWA check in `onMounted` for the web build (to catch the installed web-PWA case). The
 * returned ref matches between server and the first client render, then updates on mount.
 *
 * @returns {import('vue').Ref<boolean>} reactive installed-app flag
 */
export const usePwaInstalled = () => {
  const pwaInstalled = ref(isApp())

  onMounted(() => {
    if (!isApp()) {
      pwaInstalled.value = isPWAInstalled()
    }
  })

  return pwaInstalled
}
